import React, { useMemo } from 'react'
import { Section } from '@shared/components/section'
import showdown from 'showdown'

import styles from './style.module.scss'

interface ViewProps {
	textMd: string
}
export function View({ textMd }: ViewProps): JSX.Element {
	const html = useMemo(() => {
		const converter = new showdown.Converter({
			noHeaderId: true,
			openLinksInNewWindow: true,
		})
		return converter.makeHtml(textMd)
	}, [textMd])

	return (
		<Section className={styles.wrapper}>
			<div dangerouslySetInnerHTML={{ __html: html }} className={styles.mdContent}></div>
		</Section>
	)
}
